import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {  MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';

interface DialogData {
  message: string;
  caption: string;
  cancel: string;
  hideCancel: boolean;
  confirm: string;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ConfirmDialogComponent implements OnInit {

  public dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  public data = inject<DialogData>(MAT_DIALOG_DATA);

  

  ngOnInit(): void {
    if (!this.data.message) {
      this.data.message = 'Are you sure?';
    }

    if (!this.data.caption) {
      this.data.caption = 'Confirmation required';
    }

    if (!this.data.cancel) {
      this.data.cancel = 'No';
    }

    if (!this.data.confirm) {
      this.data.confirm = 'Yes';
    }
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
